import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonPurchase() {
  function reportPurchase(
    productId: string | number,
    itemName: 'Coins Package' | 'Membership',
    price: string | number,
    transactionId: string,
  ) {
    pushAxonEvent('purchase', {
      currency: 'USD',
      value: Number(price),
      transaction_id: transactionId,
      items: [buildAxonItem(productId, itemName, price)],
    })
  }

  return { reportPurchase }
}
